import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  lightbox = null

  async connect() {
    const { default: GLightbox } = await import('glightbox')
    this.lightbox = GLightbox()
  }
}
